<template>
  <div class="flex items-center">
    <p>{{ $t(passwordConfirmMessage) }}</p>
    <input autocomplete="off" name="hidden" type="text" class="display-none">
    <input type="password" class="input-ui" v-model="password" name="password" id="password" autocomplete="off" />
  </div>
</template>

<script>
import Axios from 'axios';
import { BODHI_HOST, ENVIRONMENT } from '../config/app-const';
import localStorage from '../helpers/localStorage';
export default {
  props: {
    authAction: {
      type: String,
      required: true,
    },
    isValid: {
      type: Function,
      default: () =>{},
    },
    promptMessage: {
      type: String,
    },
  },
  data() {
    return {
      password: ''
    };
  },
  methods: {
    validate() {
      if (ENVIRONMENT === 'development') return;
      return Axios.post(`${BODHI_HOST}/analysis/reauth`, {
        password: this.password,
        project_id: this.$route.params.project_uid,
        auth_action: this.$props.authAction,
      }).then(r => {
        localStorage.setLocalStorage('request_auth_id', r.data.auth_id);
        return r.data;
      })
    },
  },
  computed: {
    passwordConfirmMessage() {
      return this.$props.promptMessage ? this.$props.promptMessage : 'messages.confirm_delete.password_confirm_message';
    },
  },
  watch: {
    password: {
      handler(value) {
        const valid = value.length >= 6;
        this.$emit("isValid", valid);
      },
    }
  },
};
</script>

<style lang="scss" scoped>
div {
  margin-top: 30px;
}
.input-ui {
  margin-left: 10px;
  width: 25% !important;
  background: transparent !important;
  border: 1px solid #000 !important;
}
</style>
